import * as React from 'react';

import { 
  GlobalPrivateState,
  QueryParemeterPayload,
  removeQueryParam, 
  addFilterParam,
} from '../../../../api';
import { connect } from 'react-redux';
import { assign as _assign } from 'lodash';
import { remove as _remove } from 'lodash';
import classNames from 'classnames';
import './TroughFilter.scss';
import Button from 'reactstrap/lib/Button';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './TroughFilter.messages';
import TroughFilterFormOr from './TroughFilterTypes/troughFilterOr';
import { filterArtData } from 'src/api';
import { filterOverflowData, filterBackwallData, filterFormData } from './../../../../api/models/FilterForm/filter-form.data';
import TroughFilterFormAnd from './TroughFilterTypes/troughFilterAnd';

export interface FilterFormProps {
  dispatch: any;
  params: QueryParemeterPayload;
}

export interface FilterFormState {
  filter?: QueryParemeterPayload;
}

export class FilterFormPartial extends React.Component<FilterFormProps, FilterFormState> {
  
  constructor(props: FilterFormProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  
  public render() {
    const disabled = !this.filter || this.filter && Object.keys(this.filter).length === 0 ? true : false;

    return (
      <div className="partial-filter-form pb-3">
        <div className="col-12 deselect">
          <Button
            className={classNames('btn deselect p-0 mb-3', {'disabled': disabled})}
            onClick={this.handleClick}
            disabled={disabled}
          >
            <FormattedMessage {...MESSAGES.troughFilterButton} />
          </Button>
        </div>
        <TroughFilterFormOr fields={filterArtData()} queryKey="art"/>
        <TroughFilterFormAnd fields={filterFormData()} queryKey="form" />
        <TroughFilterFormOr fields={filterOverflowData()} queryKey="overflow"/>
        <TroughFilterFormOr fields={filterBackwallData()} queryKey="backwall"/>
      </div>
    );
  }

  private get filter(): QueryParemeterPayload['filter'] | undefined {
    return this.props.params && this.props.params.filter;
  }
  
  private handleClick() {
    let filter: QueryParemeterPayload | {} = {};
    this.props.dispatch(removeQueryParam('filter'));
    this.props.dispatch(addFilterParam(filter));
  }
}

export const FilterForm = connect((state: GlobalPrivateState) => ({
  params: state.queryState.params,
}))(FilterFormPartial);

export default FilterForm;